import { Map, fromJS } from "immutable";
import orderTempConstants from "../constants/orderTempConstants";
import { getNewValueFromDiffPercentage } from "../utils/math-helper/MathHelper";
import { getOrderServices } from "../utils/order-services.util";
import { v4 as uuid } from "uuid";
/**
 * Project reducer redux
 */

const initialState = Map({
	init: true,
	projectAction: false,
	projectRequest: false,
	project: Map({}),
	exports: [],
	// Order Flow V2 (EXE-232 skeleton): staged Services selection. List/selection
	// UI and pricing are filled in by EXE-234/EXE-235; defaulted to [] so existing
	// draft buffers (which never carried services) still hydrate without crashing.
	services: [],
	disciplineLevels: fromJS([]),
	tempFiles: fromJS([]),
	buildings: [
		{
			validity: {
				inputFormat: false,
				size: false,
				//lodSpecification: false,
				type: false,
				levelsValidity: true,
			},
		},
	],
	validity: Map({
		deliveryFormat: false,
		numberOfBuildings: false,
		name: false,
		specification: false,
		template: false,
	}),
	companyInfo: Map({
		clientId: null,
		clientCP: null,
		clientLocation: null,
		clientPL: null,
		name: null,
		supplierCP: null,
		supplierId: null,
		supplierPL: null,
		supplierLocation: null,
	}),
	stopPricing: false,
	hasModelsChanged: false,
	pricePerSquarePercentage: null,
	stopCalculatePercentage: false,
	stopCalculateExportPercentage: false,
	termsAndConditions: null,
	specification: null,
	template: null,
	clientCompany: Number(),
	additionalInfo: null,
});

export default (state = initialState, action) => {
	/**
	 * Update number of buildings
	 * @param {*} value - number of buildings
	 * @returns
	 */
	const updateBuilding = (value) => {
		let tempBuildings = [];
		const buildings = state.get("buildings");

		for (let index = 1; index <= value; index++) {
			const find = buildings.find((item) => item.id === index);

			if (find) {
				tempBuildings.push(find);
			} else {
				tempBuildings.push({
					id: index,
					name: `Building ${index}`,
					isCustomName: false,
					size: null,
					price: null,
					pricePerSquare: null,
					inputFormat: "",
					type: "",
					lodSpecification: "",
					levels: null,
					uniqueLevels: null,
					validity: {
						size: false,
						inputFormat: false,
						type: false,
						levelsValidity: true,
					},
				});
			}
		}

		return state.set("buildings", tempBuildings);
	};

	/**
	 * Update building data (buildings list)
	 * @param {*} data
	 * @returns
	 */
	const updateBuildingData = (data) => {
		const { stateKey, value, isValid, buildingId, isEdit = false } = data;
		let levelsValidity = true;

		const buildings = state.get("buildings");
		const index = buildings.findIndex((building) => building.id === buildingId);

		if (stateKey === "levels" && +value < +buildings[index].uniqueLevels) {
			levelsValidity = false;
		} else if (
			stateKey === "uniqueLevels" &&
			+value > +buildings[index].levels
		) {
			levelsValidity = false;
		}

		let stopPricing = false;
		if (
			stateKey === "price" ||
			stateKey === "name" ||
			stateKey === "isCustomName" ||
			stateKey === "customComplexityAdjustment"
		)
			stopPricing = true;

		return state
			.set("stopPricing", stopPricing)
			.set("tempBuildingId", buildingId)
			.setIn(
				["buildings", index, "price"],
				stopPricing || isEdit ? buildings[index].price : null
			)
			.setIn(
				["buildings", index, "pricePerSquare"],
				stopPricing || isEdit ? buildings[index].pricePerSquare : null
			)
			.setIn(["buildings", index, stateKey], value)
			.setIn(["buildings", index, "validity", stateKey], isValid)
			.setIn(["buildings", index, "validity", "levelsValidity"], levelsValidity)
			.set("stopCalculatePercentage", false)
			.set("hasModelsChanged", true);
	};

	/**
	 * Remove building form list
	 * @param {*} data
	 * @returns
	 */
	const removeBuilding = (data) => {
		const { buildingId } = data;
		const buildings = state.get("buildings");

		let tempBuildings = buildings.filter((item) => +item.id !== +buildingId);

		for (let index = 1; index <= tempBuildings.length; index++) {
			tempBuildings[index - 1].id = index;
			tempBuildings[index - 1].name = tempBuildings[index - 1].isCustomName
				? tempBuildings[index - 1].name
				: `Building ${index}`;
		}

		return state
			.set("buildings", tempBuildings)
			.set("tempBuildingId", null)
			.set("stopPricing", false)
			.set("hasModelsChanged", true);
	};

	/**
	 * Set export version - TEMP Offer
	 * @param {*} data
	 * @returns
	 */
	const setExports = (data) => {
		const { id, exportId, isSelected, price = 0, fieldKey = null } = data;

		const exports = state.get("exports");
		const findIndex = exports.findIndex((item) => item.id === id);

		let stopPricing = false;
		if (fieldKey === "price") stopPricing = true;

		if (findIndex !== -1) {
			if (+price >= 0 && !exportId) {
				return state
					.set("stopPricing", stopPricing)
					.setIn(["exports", findIndex, "customPrice"], price)
					.set("stopCalculateExportPercentage", false);
			}
			if (!isSelected) {
				const tempFilterExports = exports.filter((item) => +item.id !== +id);

				return state
					.set("stopPricing", stopPricing)
					.set("exports", tempFilterExports);
			} else {
				return state
					.set("stopPricing", stopPricing)
					.setIn(["exports", findIndex, "exportId"], exportId)
					.setIn(["exports", findIndex, "valid"], exportId ? true : false);
			}
		}

		let tempExports = [
			{
				id: id,
				exportId: exportId,
				price: null,
				customPrice: null,
				valid: exportId ? true : false,
			},
		];
		if (exports.length > 0) {
			tempExports = tempExports.concat(exports);
		}

		return state.set("stopPricing", stopPricing).set("exports", tempExports);
	};

	/**
	 * Update price on the exports and buildings object
	 * @param {*} data - { buildingPrice, exportsPrice }
	 * @returns
	 */
	const updatePrice = (data) => {
		const { buildingPrice, exportsPrice } = data;

		let tempBuildings = [];
		let tempExports = [];
		const exports = state.get("exports");
		const buildings = state.get("buildings");

		buildings &&
			buildings.forEach((building) => {
				building.price =
					buildingPrice.pricePerBuildingDetailed[building.id]?.buildingPrice;
				building.pricePerSquare =
					buildingPrice.pricePerBuildingDetailed[building.id]?.pricePerSquare;
				building.customPricePerSquare =
					buildingPrice.pricePerBuildingDetailed[building.id]?.pricePerSquare;

				building.customComplexityAdjustment = building.complexityAdjustment;

				building.customAdjustedPricePerSquare = Number(
					buildingPrice.pricePerBuildingDetailed[building.id]
						?.pricePerSquareAdjusted
				)?.toFixed(3);

				tempBuildings.push(building);
			});

		exports &&
			exports.forEach((item) => {
				item.customPrice = exportsPrice?.pricePerExport[item.exportId];
				item.price = exportsPrice?.pricePerExport[item.exportId];
				tempExports.push(item);
			});

		// stopPricing here is the loop breaker (mirrors UPDATE_BUILDING_PRICE):
		// this rebuild changes the buildings/exports array identities the
		// edit-view price effects depend on, so without it every price response
		// refires getPrice (infinite PUT /price). User-driven changes
		// (SET_EXPORTS, SET_SERVICES, updateBuildingData, removeBuilding) reset
		// stopPricing to false.
		return state
			.set("buildings", tempBuildings)
			.set("exports", tempExports)
			.set("stopPricing", true)
			.set("stopCalculatePercentage", false)
			.set("stopCalculateExportPercentage", false)
			.set("pricePerSquarePercentage", null);
	};

	const updateBuildingPrice = (data) => {
		const { buildingPrice } = data;

		let tempBuildings = [];

		const buildings = state.get("buildings");

		buildings &&
			buildings.forEach((building) => {
				building.price =
					buildingPrice.pricePerBuildingDetailed[building.id]?.buildingPrice ||
					null;
				building.pricePerSquare =
					buildingPrice.pricePerBuildingDetailed[building.id]?.pricePerSquare ||
					null;

				tempBuildings.push(building);
			});

		return state.set("buildings", tempBuildings).set("stopPricing", true);
	};

	/**
	 * Set temp offer state from single package - GET package endpoint
	 * @param {object} packageData - {packageExports, lodSpecification}
	 * @returns state
	 */
	const setStateFromPackage = (packageData) => {
		let orderExports = [];
		const { packageExports, lodSpecification } = packageData;

		//Offer exports
		packageExports &&
			packageExports.map((item) => {
				const exportChildren = item?.export?.children;
				return orderExports.push({
					exportId:
						exportChildren && exportChildren?.length > 0
							? exportChildren[0]?.id
							: item?.export?.id,
					id: item?.export?.id,
					price: item?.export?.price,
					valid: true,
				});
			});

		return state
			.set("exports", orderExports)
			.set("specification", lodSpecification?.id || null)
			.setIn(["validity", "specification"], true);
	};

	const setStateFromPackageConfiguration = (data) => {
		const {
			lodSpecification,
			exports,
			disciplineComponentCategoryLods,
			isDisciplineEqual,
		} = data;

		const tempData =
			disciplineComponentCategoryLods &&
			disciplineComponentCategoryLods.map((item) => {
				return {
					componentCategory: {
						id: item.componentCategoryId,
					},
					discipline: {
						id: item.disciplineId,
					},
					lod: {
						id: item.lodId,
						type: item.lodType,
					},
				};
			});

		return state
			.set("exports", exports)
			.set(
				"buildingDisciplineComponentCategoryLods",
				isDisciplineEqual ? null : tempData
			)
			.set(
				"specification",
				isDisciplineEqual
					? lodSpecification
					: `${lodSpecification}-draft` || null
			)
			.set(
				"configurationSpecification",
				isDisciplineEqual ? null : lodSpecification || null
			)
			.setIn(["validity", "specification"], true);
	};

	const updatePricePerSquarePercentage = (data) => {
		const { value } = data;
		const buildings = state.get("buildings");

		const tempBuildings = buildings.map((building) => {
			building.customPricePerSquare = getNewValueFromDiffPercentage(
				building.pricePerSquare,
				value
			)?.toFixed(2);

			building.customAdjustedPricePerSquare = Number(
				building.customPricePerSquare
			)?.toFixed(3);
			building.price = +(
				building.customAdjustedPricePerSquare * +building.size
			)?.toFixed(2);

			return building;
		});

		return state
			.set("buildings", tempBuildings)
			.set("stopCalculatePercentage", true)
			.set("hasModelsChanged", true);
	};

	const updateExportPricePercentage = (data) => {
		const { value } = data;
		const exports = state.get("exports");

		const tempExports = exports.map((item) => {
			item.customPrice = +getNewValueFromDiffPercentage(
				item.price,
				value
			)?.toFixed(2);

			return item;
		});

		return state
			.set("exports", tempExports)
			.set("stopCalculateExportPercentage", true);
	};

	const setTempCompanyInfo = (data) => {
		const order = data;

		const companyInfo = {
			//offer
			name: order?.name || "",
			//client
			clientId: order?.clientCompany?.id || null,
			clientCP: order?.clientContactPerson?.id || null,
			clientLocation: null,
			clientPL: order?.clientProjectLead?.id || null,
			//reseller
			resellerCP: order?.resellerContactPerson?.id || null,
			resellerId: order?.resellerCompany?.id || null,
			resellerPL: order?.resellerProjectLead?.id || null,
			resellerLocation: null,
			//supplier
			supplierCP: order?.suplierContactPerson?.id || null,
			supplierId: order?.bimifyCompany?.id || null,
			supplierPL: order?.suplierProjectLead?.id || null,
			supplierLocation: null,
		};

		return state
			.set("tempCompanyInfo", fromJS(companyInfo))
			.set("companyInfo", fromJS(companyInfo));
	};

	/**
	 * UPDATE create offer levels - INTEGRATION
	 * @param {object} disciplineLevels  - contains discipline and levels
	 * @returns
	 */
	const updateCreateOfferLevels = (data) => {
		const { disciplineLevels } = data;

		const tempDisciplineLevels = state.get("disciplineLevels")?.toJS() || [];

		let stateDisciplineLevels = [];

		disciplineLevels &&
			disciplineLevels.length > 0 &&
			disciplineLevels.forEach((disciplineLevel, i) => {
				const tempDisciplineLevel =
					tempDisciplineLevels &&
					tempDisciplineLevels.find(
						(tempDisciplineLevel) =>
							+tempDisciplineLevel.discipline === +disciplineLevel?.disciplineId
					);
				const tempLevels = tempDisciplineLevel?.levels;

				//---------------------------------------------------
				const levels = disciplineLevel?.levels || [];
				let stateLevels = [];

				const sortedLevels =
					levels &&
					levels.sort((a, b) => {
						return b.level - a.level;
					});

				// ---------------------------------------------------
				sortedLevels &&
					sortedLevels.length > 0 &&
					sortedLevels.map((level) => {
						const findLevel =
							tempLevels &&
							tempLevels.find(
								(tempLevel) => +tempLevel?.level === level?.level
							);

						return stateLevels.push({
							id: null,
							key: `${disciplineLevel?.disciplineId}_floor__${level?.level}`,
							level: level?.level,
							file: null,
							tempFileId: findLevel ? findLevel?.tempFileId : null,
							valid: true,
							path: "",
							elevation: level?.elevation || null,
							thickness: level?.thickness || null,
						});
					});

				return stateDisciplineLevels.push({
					discipline: disciplineLevel?.disciplineId,
					levels: stateLevels,
				});
			});

		return state.set("disciplineLevels", fromJS(stateDisciplineLevels));
	};

	/**
	 * SET create order file per level - INTEGRATION
	 * @param {string} levelKey - level key
	 * @param {string} fileId - file id
	 * @param {string} disciplineId - discipline id
	 * @returns
	 */
	const setCreateOrderFilePerLevel = (data) => {
		const { levelKey, fileId, disciplineId } = data;

		const disciplineLevels = state.get("disciplineLevels")?.toJS() || [];

		const disciplineLevel =
			disciplineLevels &&
			disciplineLevels.find(
				(disciplineLevel) => +disciplineLevel.discipline === +disciplineId
			);

		const levels = disciplineLevel?.levels;
		const disciplineLevelIndex = disciplineLevels.indexOf(disciplineLevel);
		const levelIndex =
			levels && levels.findIndex((level) => level.key === levelKey);

		return state.setIn(
			[
				"disciplineLevels",
				disciplineLevelIndex,
				"levels",
				levelIndex,
				"tempFileId",
			],
			fileId
		);
	};

	/**
	 * SET temp create order files - INTEGRATION
	 * @param {Array} files - files data
	 * @returns
	 */
	const setTempCreateOrderFiles = (files) => {
		const tempFiles = state.get("tempFiles")?.toJS() || [];

		files &&
			files.forEach((file) =>
				tempFiles.push({
					name: file.name,
					id: uuid(),
					file,
				})
			);

		return state.set("tempFiles", fromJS(tempFiles));
	};

	switch (action.type) {
		case orderTempConstants.SET_STATE_FIELD_VALUE:
			return state
				.set("tempBuildingId", null)
				.set(
					"stopPricing",
					action.data.stateKey === "specification" ||
						action.data.stateKey === "numberOfBuildings"
						? false
						: true
				)
				.set(action.data.stateKey, action.data.value)
				.setIn(["validity", action.data.stateKey], action.data.isValid)
				.set(
					"hasModelsChanged",
					action.data.stateKey === "numberOfBuildings"
						? true
						: state.get("hasModelsChanged")
				);

		case orderTempConstants.SET_COMPANY_STATE_FIELD_VALUE:
			return state.setIn(
				["companyInfo", action.data.stateKey],
				action.data.value
			);
		case orderTempConstants.CLEAR_COMPANY_STATE_VALUE:
			return state.set("companyInfo", state.get("tempCompanyInfo"));

		case orderTempConstants.SET_TEMP_COMPANY_INFO:
			return setTempCompanyInfo(action.data);

		case orderTempConstants.SET_TEMP_PROJECT:
			const order = action.data;

			const buildings = order.buildings;

			let orderExports = [];
			let tempBuildings = [];

			// Services attached to the order (top-level orderServiceManuals) staged
			// so the single-view ServicesEdit reads them like ExportsEdit reads
			// exports — { id } drives manualIds + the price payload, price is the
			// snapshot for the non-estimating subtotal fallback.
			const orderServices = getOrderServices(order).map((service) => ({
				id: service.id,
				title: service.title,
				price: service.price,
			}));

			//Delivery Format
			let orderDeliveryFormat = order.orderDeliveryFormats[0].deliveryFormat.id;

			//Export format
			order.orderExports &&
				order.orderExports.map((orderExport) => {
					return orderExports.push({
						id: orderExport.export?.parent
							? orderExport.export?.parent.id
							: orderExport.export.id,
						exportId: orderExport.export.id,
						price: orderExport.price,
						customPrice: orderExport.customPrice,
						valid: true,
					});
				});

			//Buildings
			buildings &&
				buildings.map((building, index) => {
					return tempBuildings.push({
						id: index + 1,
						buildingId: building.id,
						name: building.name,
						size: building.size,
						price: building.price,
						systemAdjustedTotalPrice: Number(
							building.systemAdjustedTotalPrice
						)?.toFixed(2),
						pricePerSquare: building.pricePerSquare,
						customPricePerSquare: building.customPricePerSquare,
						systemComplexityAdjustmentPercentage:
							building.systemComplexityAdjustmentPercentage,
						complexityAdjustment: Number(
							building.systemComplexityAdjustmentPercentage * 100
						)?.toFixed(2),
						customComplexityAdjustment: Number(
							building.customComplexityAdjustmentPercentage * 100
						)?.toFixed(2),

						adjustedPricePerSquare: Number(
							building.systemAdjustedPricePerSquare
						)?.toFixed(3),
						customAdjustedPricePerSquare: Number(
							building.customSystemAdjustedPricePerSquare ||
								building.systemAdjustedPricePerSquare
						)?.toFixed(3),
						isCustomName: true,
						inputFormat: building?.inputFormat?.id,
						type: building.type.id,
						lodSpecification: building.lodSpecification?.id || null,
						levels: building?.levelsTotal || null,
						uniqueLevels: building?.uniqueLevels || null,
						validity: {
							size: true,
							inputFormat: true,
							type: true,
							levelsValidity: true,
						},
					});
				});

			const initialTempOffer = {
				additionalInfo: order.additionalInfo,
				buildings: tempBuildings,
				tempBuildingId: null,
				specification: tempBuildings[0]?.lodSpecification || null,
				clientCompany: order.clientCompany.id,
				pricePerSquarePercentage: +order.pricePerSquarePercentage,
				vatPercentage: order.vatPercentage || 0,
				deliveryDays: order.deliveryDays || 0,
				template: order.revitFile?.id || null,
				name: order.name,
				numberOfBuildings: tempBuildings.length,
				discount: Number(order.clientDiscount).toFixed(2) || 0,
				exports: orderExports,
				services: orderServices,
				deliveryFormat: orderDeliveryFormat,
			};

			return state
				.set("additionalInfo", order.additionalInfo)
				.set("buildings", tempBuildings)
				.set("tempBuildingId", null)
				.set("specification", tempBuildings[0]?.lodSpecification || null)
				.set("clientCompany", order.clientCompany.id)
				.set("pricePerSquarePercentage", +order.pricePerSquarePercentage)
				.set("vatPercentage", order.vatPercentage || 0)
				.set("deliveryDays", order.deliveryDays || 0)
				.set("template", order.revitFile?.id || null)
				.set("name", order.name)
				.set("numberOfBuildings", tempBuildings.length)
				.set("discount", Number(order.clientDiscount).toFixed(2) || 0)
				.set("exports", orderExports)
				.set("services", orderServices)
				.set("deliveryFormat", orderDeliveryFormat)
				.setIn(["validity", "deliveryFormat"], true)
				.setIn(["validity", "numberOfBuildings"], true)
				.setIn(["validity", "name"], true)
				.setIn(["validity", "specification"], true)
				.setIn(["validity", "template"], true)
				.setIn(
					["validity", "vatPercentage"],
					!!order.vatPercentage ? true : false
				)
				.setIn(
					["validity", "deliveryDays"],
					!!order.deliveryDays ? true : false
				)
				.set("initialTempOffer", fromJS(initialTempOffer))
				.set("hasModelsChanged", false);

		case orderTempConstants.UPDATE_BUILDING:
			return updateBuilding(action.data);

		case orderTempConstants.UPDATE_BUILDING_DATA:
			return updateBuildingData(action.data);

		case orderTempConstants.UPDATE_CREATE_OFFER_LEVELS:
			return updateCreateOfferLevels(action.data);

		case orderTempConstants.SET_CREATE_ORDER_FILE_PER_LEVEL:
			return setCreateOrderFilePerLevel(action.data);

		case orderTempConstants.SET_TEMP_CREATE_ORDER_FILES:
			return setTempCreateOrderFiles(action.data);

		case orderTempConstants.REMOVE_BUILDING:
			return removeBuilding(action.data);

		case orderTempConstants.UPDATE_PRICE:
			return updatePrice(action.data);

		case orderTempConstants.UPDATE_BUILDING_PRICE:
			return updateBuildingPrice(action.data);

		case orderTempConstants.SET_INIT_NUMBER_OF_BUILDINGS:
			return state
				.set(action.data.key, action.data.value)
				.setIn(["validity", action.data.key], true)
				.set("init", false)
				.set("hasModelsChanged", false);

		case orderTempConstants.SET_EXPORTS:
			return setExports(action.data);

		case orderTempConstants.SET_SERVICES:
			// Reset stopPricing (mirrors setExports) so the order price recomputes
			// on each service toggle. A prior getPrice success sets stopPricing=true
			// (UPDATE_BUILDING_PRICE), which would otherwise gate the recompute and
			// freeze the running total on the Services step (EXE-235).
			return state.set("services", action.data).set("stopPricing", false);

		case orderTempConstants.SET_STATE_FROM_PACKAGE:
			return setStateFromPackage(action.data);

		case orderTempConstants.SET_STATE_FROM_PACKAGE_CONFIGURATION:
			return setStateFromPackageConfiguration(action.data);

		case orderTempConstants.SET_TEMP_TERMS_AND_CONDITIONS:
			return state.set("termsAndConditions", action.data);

		case orderTempConstants.SET_TEMP_ADDITIONAL_INFO:
			return state.set("additionalInfo", action.data);

		case orderTempConstants.SET_TEMP_INPUT_REQUIREMENT:
			return state.set("inputRequirement", action.data);

		case orderTempConstants.CLEAR_TEMP_PROJECT:
			const { canSaveAdditionalInfo } = action.data;

			if (!!canSaveAdditionalInfo) {
				return initialState
					.set("additionalInfo", state.get("additionalInfo"))
					.set("termsAndConditions", state.get("termsAndConditions"))
					.set("companyInfo", state.get("companyInfo"))
					.set("tempCompanyInfo", state.get("tempCompanyInfo"));
			}

			return initialState;

		case orderTempConstants.UPDATE_PRICE_PER_SQUARE_PERCENTAGE:
			return updatePricePerSquarePercentage(action.data);

		case orderTempConstants.UPDATE_EXPORT_PRICE_PERCENTAGE:
			return updateExportPricePercentage(action.data);

		case orderTempConstants.RESET_SUMMARY_VIEW:
			return state.set(
				"deliveryDays",
				state.getIn(["initialTempOffer", "deliveryDays"])
			);

		case orderTempConstants.RESET_ORDER_VIEW:
			return state
				.set(
					"deliveryFormat",
					state.getIn(["initialTempOffer", "deliveryFormat"])
				)
				.set("service", state.getIn(["initialTempOffer", "service"]))
				.set("template", state.getIn(["initialTempOffer", "template"]));

		case orderTempConstants.RESET_MODELS_VIEW:
			const buildingsJS = state
				.getIn(["initialTempOffer", "buildings"])
				?.toJS();
			return state
				.set("buildings", buildingsJS)
				.set(
					"numberOfBuildings",
					state.getIn(["initialTempOffer", "numberOfBuildings"])
				)
				.set(
					"pricePerSquarePercentage",
					state.getIn(["initialTempOffer", "pricePerSquarePercentage"])
				)
				.set("init", true)
				.set("hasModelsChanged", false);

		case orderTempConstants.RESET_EXPORTS_VIEW:
			return state
				.set("exports", state.getIn(["initialTempOffer", "exports"])?.toJS())
				.set(
					"exportPricePercentage",
					state.getIn(["initialTempOffer", "exportPricePercentage"])
				);

		case orderTempConstants.RESET_SERVICES_VIEW:
			return state.set(
				"services",
				state.getIn(["initialTempOffer", "services"])?.toJS() || []
			);

		case orderTempConstants.RESET_SUMMARY_PRICE_VIEW:
			return state
				.set("discount", state.getIn(["initialTempOffer", "discount"]))
				.set(
					"vatPercentage",
					state.getIn(["initialTempOffer", "vatPercentage"])
				);
		case orderTempConstants.RESET_BIM_SPECIFICATION_VIEW:
			return state.set(
				"specification",
				state.getIn(["initialTempOffer", "specification"])
			);

		default:
			return state;
	}
};
